import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../utils/constants";

const useFetch = (url, dependencies = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetch(`${ API_BASE_URL }${ url }`, {
      timeout: 60000 // 60 seconds timeout
    })
      .then((res) => res.json())
      .then((json) => {
        setData(json);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, dependencies);

  return { data, loading, error };
};

export default useFetch;
